// Only answers backed by nordicprolo.se or the BokaDirekt profile (2026-09-28).
export const faq = [
  {
    id: "vad-ar-proloterapi",
    q: "Vad är proloterapi?",
    a: "Proloterapi är en icke-kirurgisk injektionsbehandling. En lösning, vanligtvis med medicinsk dextros, injiceras i det område där besvären sitter för att stimulera kroppens egen läkningsprocess i ledband, senor och leder.",
  },
  {
    id: "remiss",
    q: "Behöver jag remiss?",
    a: "Nej. Ingen remiss krävs – du bokar din tid direkt via BokaDirekt.",
  },
  {
    id: "forsta-besoket",
    q: "Hur går det första besöket till?",
    a: "Nybesöket tar cirka 60 minuter. Läkaren går igenom dina besvär, din sjukdomshistoria och tidigare behandlingar, undersöker dig och bedömer om behandling är lämplig. Du får en förklaring av behandlingen och en individuell plan.",
  },
  {
    id: "distans",
    q: "Kan jag få en första bedömning på distans?",
    a: "Ja. Nya patienter kan boka en distanskonsultation via video eller telefon.",
  },
  {
    id: "antal",
    q: "Hur många behandlingar behövs?",
    a: "Det varierar beroende på besvären och hur kroppen svarar. Flera tillfällen kan behövas. För nervproloterapi rekommenderas vanligtvis en serie om fyra till sex behandlingar under några veckor.",
  },
  {
    id: "efterat",
    q: "Vad kan jag känna efter behandlingen?",
    a: "Lätt ömhet och svullnad i området kan förekomma. Du kan gradvis återgå till dina vanliga aktiviteter och får tydliga instruktioner efter behandlingen.",
  },
  {
    id: "var",
    q: "Var tar ni emot?",
    a: "I Nacka Forum (Forumvägen 14, plan 11) och i Göteborg, där läkaren är på plats en gång per månad. Lediga tider för båda mottagningarna finns på BokaDirekt.",
  },
];
